import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';
import { isObjectLike } from 'lodash';

export const epodActions = {
  EPOD_SEND_OTP: 'EPOD_SEND_OTP',
  EPOD_VERIFY_OTP: 'EPOD_VERIFY_OTP',
  EPOD_GET_FORM: 'EPOD_GET_FORM',
  EPOD_POST_IMAGE: 'EPOD_POST_IMAGE',
  EPOD_POST_FORM: 'EPOD_POST_FORM'
};

const errorMessage = 'Failed to perform operation';

export const epodVerifyOTPAction = (data: Object) => ({
  type: epodActions.EPOD_VERIFY_OTP,
  payload: data
});

export const epodGetFormAction = (data: Object) => ({
  type: epodActions.EPOD_GET_FORM,
  payload: data
});

export const epodPostFormAction = (data: Object) => ({
  type: epodActions.EPOD_POST_FORM,
  payload: data
});

export const postUploadImage = (data: Object) => ({
  type: epodActions.EPOD_POST_IMAGE,
  payload: data
});

export const sendOtp = obj => (dispatch: Function, getState) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'epodSendOtp',
    method: 'POST',
    pathVariables: [{ key: '{token}', val: obj.token }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (obj.resendOtp) {
          toastr.success(res.payload || 'OTP sent succesfully');
        }
      } else if (res.status === 'FAILURE') {
        if (obj.resendOtp) {
          toastr.error(res.errorMessage || 'Failed to perform operation');
        }
      }
    },
    failureCb: res => {
      if (obj.resendOtp) {
        toastr.error(res.errorMessage || 'Failed to perform operation');
      }
    },
    catchCb: res => {
      if (obj.resendOtp) {
        toastr.error(res.errorMessage || 'Failed to perform operation');
      }
    }
  };
  return makeApiCall(requestObj);
};

export const verifyOtp = obj => (dispatch: Function, getState) => {
  const { epodState } = getState();

  dispatch(
    epodVerifyOTPAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'epodVerifyOtp',
    method: 'POST',
    pathVariables: [{ key: '{token}', val: obj.token }],
    replaceParamsArr: [{ key: 'otp', val: obj.otp }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        toastr.success(res.payload || 'Operation successful');
        dispatch(
          epodVerifyOTPAction({
            isLoading: false,
            isLoaded: true,
            epodData: [],
            otpVerified: true,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          epodVerifyOTPAction({
            isLoading: false,
            isLoaded: true,
            epodData: [],
            error: res.errorMessage || errorMessage
          })
        );
      }
    },
    failureCb: res => {
      toastr.error(res.errorMessage || 'Operation failed');
      dispatch(
        epodVerifyOTPAction({
          isLoading: false,
          isLoaded: true,
          epodData: [],
          error: res.errorMessage || errorMessage
        })
      );
    },
    catchCb: res => {
      toastr.error('Operation failed');
      dispatch(
        epodVerifyOTPAction({
          isLoading: false,
          isLoaded: true,
          epodData: [],
          error: errorMessage
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getEpodForm = (obj: Object) => (dispatch: Function, getState) => {
  const { epodState } = getState();

  dispatch(
    epodGetFormAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'epodFormDetails',
    method: 'GET',
    pathVariables: [{ key: '{token}', val: obj.token }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          epodGetFormAction({
            isLoading: false,
            isLoaded: true,
            epodData: res.payload,
            otpVerified: true,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          epodGetFormAction({
            isLoading: false,
            isLoaded: true,
            epodData: [],
            error: res.errorMessage || errorMessage
          })
        );
      }
    },
    failureCb: res => {
      toastr.error(res.errorMessage || 'Operation failed');
      dispatch(
        epodGetFormAction({
          isLoading: false,
          isLoaded: true,
          epodData: [],
          error: res.errorMessage || errorMessage
        })
      );
    },
    catchCb: res => {
      toastr.error('Operation failed');
      dispatch(
        epodGetFormAction({
          isLoading: false,
          isLoaded: true,
          epodData: [],
          error: errorMessage
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const postEpodForm = (data: Object, obj: String) => (
  dispatch: Function,
  getState
) => {
  dispatch(
    epodGetFormAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'epodFormDetails',
    method: 'POST',
    data: data,
    pathVariables: [{ key: '{token}', val: obj.token }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          epodPostFormAction({
            isLoading: false,
            isLoaded: true,
            responseOtp: res.payload,
            otpVerified: true,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          epodPostFormAction({
            isLoading: false,
            isLoaded: true,
            responseOtp: null,
            error: res.errorMessage || errorMessage
          })
        );
      }
    },
    failureCb: res => {
      toastr.error(res.errorMessage || 'Operation failed');
      dispatch(
        epodPostFormAction({
          isLoading: false,
          isLoaded: true,
          responseOtp: null,
          error: res.errorMessage || errorMessage
        })
      );
    },
    catchCb: res => {
      toastr.error('Operation failed');
      dispatch(
        epodPostFormAction({
          isLoading: false,
          isLoaded: true,
          responseOtp: null,
          error: errorMessage
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const uploadImage = (
  file: File,
  obj: Object,
  onSuccessfulImageUpload: Function
) => (dispatch: Function, getState) => {
  if (!file) {
    dispatch(
      postUploadImage({
        isLoading: false,
        isLoaded: true,
        imageUrl: null,
        error: null
      })
    );
    return;
  }

  dispatch(
    postUploadImage({
      isLoading: true,
      isLoaded: false
    })
  );
  let formData = new FormData();
  formData.set('key', obj.checkFile);
  formData.append('file', file);

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'uploadEpodFile',
    postFormData: true,
    data: formData,
    contentType: undefined,
    method: 'POST',
    pathVariables: [{ key: '{token}', val: obj.token }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          postUploadImage({
            isLoading: false,
            isLoaded: true
          })
        );
        onSuccessfulImageUpload(res.payload);
        toastr.success('Image uploaded successfully');
      } else if (res.status === 'FAILURE') {
        dispatch(
          postUploadImage({
            isLoading: false,
            isLoaded: true
          })
        );
      }
    },
    failureCb: res => {
      toastr.error(
        res.errorMessage || 'Failed to upload image.Please try again.'
      );
      dispatch(
        postUploadImage({
          isLoading: false,
          isLoaded: true
        })
      );
    },
    catchCb: res => {
      toastr.error('Failed to upload image.Please try again.');
      dispatch(
        postUploadImage({
          isLoading: false,
          isLoaded: true
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const retriggerOtp = (obj: Object, callback: Function) => (
  dispatch: Function
) => {
  dispatch(
    epodGetFormAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'retriggerOtp',
    method: 'GET',
    pathVariables: [{ key: '{token}', val: obj.token }],
    successCb: res => {
      callback(res);
      dispatch(
        epodGetFormAction({
          isLoading: false,
          isLoaded: true,
          responseOtp: res.payload
        })
      );
    },
    failureCb: res => {
      callback(res);
      epodGetFormAction({
        isLoading: false,
        isLoaded: true
      });
    },
    catchCb: res => {
      callback(res);
      epodGetFormAction({
        isLoading: false,
        isLoaded: true
      });
    }
  };

  return makeApiCall(requestObj);
};
